import { render, staticRenderFns } from "./SystemPlatConfig.vue?vue&type=template&id=1f5a3d34&"
import script from "./SystemPlatConfig.vue?vue&type=script&lang=js&"
export * from "./SystemPlatConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports